import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';

interface ChatHeaderProps {
  title: string;
  chatId?: string;
  isOnline?: boolean;
  isSyncing?: boolean;
  isConnected?: boolean;
  onTitleClick?: (chatId: string) => void;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({
  title,
  chatId,
  isOnline = true,
  isSyncing = false,
  isConnected = false,
  onTitleClick
}) => {
  const { t } = useI18n();
  const handleTitleClick = () => {
    if (chatId && onTitleClick) {
      onTitleClick(chatId);
    }
  };

  return (
  <div className="chat-header">
    <div className="chat-title-container d-flex flex-row">
      <h2 
        className={`chat-title ${chatId && onTitleClick ? 'clickable' : ''}`}
        onClick={handleTitleClick}
        title={chatId && onTitleClick ? t('dialogs.rename.title') : undefined}
      >
        {title}
      </h2>
      <div className="chat-status-indicators ms-2">
        {!isOnline && (
          <div className="status-indicator offline" title={t('dialogs.status.offline')}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
            </svg>
          </div>
        )}
        {isOnline && isSyncing && (
          <div className="status-indicator syncing" title={t('dialogs.status.syncing')}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" className="spinning">
              <path d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"/>
            </svg>
          </div>
        )}
        {isOnline && !isSyncing && isConnected && (
          <div className="status-indicator connected" title={t('dialogs.status.connected')}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
            </svg>
          </div>
        )}
        {isOnline && !isSyncing && !isConnected && (
          <div className="status-indicator disconnected" title={t('dialogs.status.disconnected')}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"/>
            </svg>
          </div>
        )}
      </div>
    </div>
  </div>
  );
};

export default ChatHeader; 